import {Component, ChangeDetectionStrategy, Input, OnInit} from '@angular/core';
import { enterComponent } from '../animations';

import { OnlineMenuNavTypesComponent } from '../online-menu-nav-types.shared.component';
import {filter, map} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'shared-online-menu-nav-for-mobile',
    templateUrl: './online-menu-nav-for-mobile.shared.component.html',
    styleUrls: ['./online-menu-nav-for-mobile.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        enterComponent(0)
    ]
})
export class OnlineMenuNavForMobileComponent extends OnlineMenuNavTypesComponent implements OnInit {
    public activeListener$!: Subscription;
    public activeId: number = null;

    ngOnInit(): void {
        this.searchTerm$ = this.controllers.filters.getOnlineMenuFiltersSearchTerm$();
        this.onlineMenuPages$ = this.controllers.onlineMenu.onlineMenuPagesFiltered$();
        this.hasScrolled$ = this.drawCollapseService.drawProgress$
            .pipe(
                map(val => {
                    return val < .5;
                })
            );
        if (this.registryId) {
            this.activeListener$ = this.subNavService.currentTargets$
                .pipe(
                    map(obj => obj[this.registryId]),
                    filter(obj => !!obj === true),
                ).subscribe(active => {
                    this.activeId = active;
                });
        }
    }
}
